import {
  Box,
  Button,
  Card,
  Divider,
  Grid,
  LinearProgress,
  List,
  ListItem,
  Pagination,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import Header from "../common/Header";
import Footer from "../common/Footer";
import useFetch from "./FetchData/useFetch";

const Blog = () => {
  const {
    articleDetails,
    getArticle,
    blogData,
    loading,
    searchBlogValue,
    searchCategoryValue,
    setSearchBlogValue,
    setSearchCategoryValue,
  } = useFetch();
  const { category } = useParams();

  const navigate = useNavigate();
  const location = useLocation();
  const mobileScreen = useMediaQuery(
    "(min-width: 300px) and (max-width:599px)"
  );
  const tabScreen = useMediaQuery("(min-width: 600px) and (max-width:1023px)");
  const laptopScreen = useMediaQuery(
    "(min-width: 1024px) and (max-width: 1240px)"
  );
  const mediumLaptopScreen = useMediaQuery(
    "(min-width: 1241px) and (max-width: 1440px)"
  );
  const largeLaptopScreen = useMediaQuery(
    "(min-width: 1441px) and (max-width: 1663px)"
  );

  const [currentPage, setCurrentPage] = useState(1);
  const articlesPerPage = 6;
  const [uniqueCategory, setUniqueCategory] = useState(new Set());
  const [filteredBlogs, setFilteredBlogs] = useState([]);
  // console.log(uniqueCategory, "gtetetteyi");
  // console.log(filteredBlogs, "gttrtr");

  const categories = [
    ...new Set(articleDetails.map((article) => article.category)),
  ].filter((category) => category.trim() !== "");

  const [selectedCategory, setSelectedCategory] = useState(0);
  const [selectedCategoryData, setSelectedCategoryData] = useState("");

  const filteredArticles = articleDetails.filter((article) => {
    const selectedCategoryValue = categories[selectedCategory];
    return article.category === selectedCategoryValue;
  });

  const indexOfLastArticle = currentPage * articlesPerPage;
  const indexOfFirstArticle = indexOfLastArticle - articlesPerPage;
  const currentArticles = filteredArticles.slice(
    indexOfFirstArticle,
    indexOfLastArticle
  );

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const handleBlogInputChange = (e) => {
    setSearchBlogValue(e.target.value);
  };
  const handleCategoryInputChange = (event) => {
    setSearchCategoryValue(event.target.value);

    handleBlogInputChange({ target: { value: "" } });
  };
  const handleCategoryClick = (index) => {
    setSelectedCategory(index);

    setCurrentPage(1);
  };

  const handleCategorySelect = (category) => {
    setSearchCategoryValue(category);
    setSelectedCategoryData(category);
  };

  const handleBlogNavigate = (ogUrl, category) => {
    // navigate(`/college/${category}/${ogUrl}`);
    navigate(`/blog/${ogUrl}`);
  };
  useEffect(() => {
    if (selectedCategoryData) {
      setFilteredBlogs(
        blogData.filter(
          (blog) =>
            blog.category &&
            blog.category.toLowerCase() === selectedCategoryData.toLowerCase()
        )
      );
    } else {
      setFilteredBlogs([]);
    }
  }, [selectedCategoryData, blogData]);

  useEffect(() => {
    if (searchCategoryValue.trim() === "") {
      setUniqueCategory(new Set());
    } else {
      setUniqueCategory(
        new Set(
          blogData
            .map((blog) => blog.category)
            .filter(
              (category) =>
                category &&
                category
                  .toLowerCase()
                  .includes(searchCategoryValue.toLowerCase().trim())
            )
        )
      );
    }
  }, [searchCategoryValue, blogData]);
  useEffect(() => {
    getArticle();
  }, []);

  useEffect(() => {
    navigate("/blog");
  }, [location.pathname]);

  return (
    <div>
      <Header />
      <Grid
        sx={{
          display: "flex",
          flexDirection: "column",
          textAlign: "center",
          padding: "20px",
        }}
      >
        <Typography
          sx={{
            fontWeight: "bold",
            fontSize: "1.5rem",
          }}
        >
          Explore Our Unique Offerings!
        </Typography>

        {/* Main Heading */}
        {/* <Typography
                    sx={{
                        fontWeight: 'bold',
                        fontSize: { md: '4rem', xs: '3rem' },
                    }}
                >
                    Painting Solutions with<br />{' '}

                </Typography> */}
        <Typography
          sx={{
            fontWeight: "bold",
            fontSize: { md: "2.5rem", xs: "2rem" },
            color: "#ff5722",
          }}
        >
          Reef Environmental Education Foundation
        </Typography>

        {/* Subheading */}
        <Typography
          sx={{
            fontSize: "1.5rem",
            color: "#6c6c6c",
            textAlign: "center",
          }}
        >
          Discover expert insights into Reef Services, explore the latest trends
        </Typography>
      </Grid>

      <Grid
        sx={{
          bottom: 0,
          pt: 2,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          color: "#FFFFFF",
        }}
      >
        <Grid style={{ position: "relative" }}>
          <Grid
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: "2px solid #1d1a57",
              borderRadius: 10,
              width: mobileScreen ? 350 : 600,
              "@media (min-width: 1024px) and (max-width: 1440px)": {
                width: 550,
              },
              background: "#f0f8ff",
            }}
          >
            <Grid
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                justifyContent: "center",
                "@media (min-width: 1024px) and (max-width: 1440px)": {
                  px: 2,
                },
                px: mobileScreen ? 3 : 5,
              }}
            >
              <TextField
                size="small"
                placeholder="Search Category"
                variant="standard"
                InputProps={{
                  disableUnderline: true,
                  style: {
                    fontSize: mobileScreen ? 10 : 14,
                    textAlign: "center",
                  },
                }}
                sx={{
                  borderRadius: 0,
                  width: mobileScreen ? 70 : 150,
                  py: mobileScreen ? "4px" : 1,
                }}
                value={searchCategoryValue}
                onChange={handleCategoryInputChange}
                autoComplete="off"
              />
              {searchCategoryValue.trim() !== "" && !selectedCategoryData && (
                <Grid
                  sx={{
                    background: "#FFF",
                    position: "absolute",
                    top: "calc(100% + 5px)",
                    left: 0,
                    width: "100%",
                    zIndex: 1,
                    maxHeight: "160px",
                    overflowY: "auto",
                    overflowX: "hidden",
                  }}
                >
                  <List
                    sx={{
                      width: { xs: "300px", sm: "400px", md: "500px" },
                    }}
                  >
                    {loading && (
                      <ListItem sx={{ color: "#000" }}>Loading...</ListItem>
                    )}
                    {!loading &&
                      Array.from(uniqueCategory).map((category) => (
                        <ListItem
                          key={category}
                          onClick={() => handleCategorySelect(category)}
                        >
                          <Typography
                            sx={{
                              cursor: "pointer",
                              color: "#000",
                            }}
                          >
                            {category}
                          </Typography>
                        </ListItem>
                      ))}
                    {!loading &&
                      uniqueCategory.size === 0 &&
                      searchCategoryValue.trim() !== "" && (
                        <ListItem>
                          <Typography sx={{ color: "#000" }}>
                            No Category Found
                          </Typography>
                        </ListItem>
                      )}
                  </List>
                </Grid>
              )}
            </Grid>
            {/* <Divider
                            orientation="vertical"
                            flexItem
                            sx={{ height: mobileScreen ? 30 : 45 }}
                        /> */}
            <Grid
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                justifyContent: "center",
                px: mobileScreen ? 3 : 5,
              }}
            >
              <TextField
                value={searchBlogValue}
                onChange={handleBlogInputChange}
                autoComplete="off"
                placeholder="Search Blog Title"
                variant="standard"
                InputProps={{
                  endAdornment: (
                    <SearchIcon
                      style={{
                        marginRight: mobileScreen ? "2px" : "8px",
                        color: "#1d1a57",
                      }}
                    />
                  ),
                  disableUnderline: true,
                  style: { fontSize: mobileScreen ? 10 : 14 },
                }}
                sx={{ borderRadius: 0, width: mobileScreen ? 160 : 300 }}
              />
              {searchBlogValue.trim() !== "" &&
                !selectedCategoryData &&
                searchCategoryValue.trim() === "" && (
                  <Grid
                    sx={{
                      background: "#FFF",
                      position: "absolute",
                      top: "calc(100% + 5px)",
                      left: 0,
                      width: "100%",
                      zIndex: 1,
                      maxHeight: "160px",
                      overflowY: "auto",
                      overflowX: "hidden",
                    }}
                  >
                    <List
                      sx={{
                        width: { xs: "300px", sm: "400px", md: "500px" },
                      }}
                    >
                      <ListItem>
                        <Typography sx={{ color: "#000" }}>
                          Please select the category first
                        </Typography>
                      </ListItem>
                    </List>
                  </Grid>
                )}
              {selectedCategoryData && searchBlogValue.trim() !== "" && (
                <Grid
                  sx={{
                    background: "#FFF",
                    position: "absolute",
                    top: "calc(100% + 5px)",
                    left: 0,
                    width: "100%",
                    zIndex: 1,
                    maxHeight: "160px",
                    overflowY: "auto",
                    overflowX: "hidden",
                  }}
                >
                  <List
                    sx={{
                      width: { xs: "300px", sm: "400px", md: "500px" },
                    }}
                  >
                    {loading && (
                      <ListItem sx={{ color: "#000" }}>Loading...</ListItem>
                    )}
                    {!loading &&
                      filteredBlogs
                        .filter((blog) =>
                          blog.blogTitle
                            .toLowerCase()
                            .includes(searchBlogValue.toLowerCase().trim())
                        )
                        .map((blog) => (
                          <ListItem
                            key={blog.id}
                            onClick={() => handleBlogNavigate(blog.ogUrl)}
                          >
                            <Typography
                              sx={{ color: "#000", cursor: "pointer" }}
                            >
                              {blog.blogTitle}
                            </Typography>
                          </ListItem>
                        ))}
                    {!loading &&
                      filteredBlogs.filter((blog) =>
                        blog.blogTitle
                          .toLowerCase()
                          .includes(searchBlogValue.toLowerCase().trim())
                      ).length === 0 &&
                      searchBlogValue.trim() !== "" && (
                        <ListItem>
                          <Typography sx={{ color: "#000" }}>
                            No Colleges Found
                          </Typography>
                        </ListItem>
                      )}
                  </List>
                </Grid>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid
        sx={{
          p: laptopScreen ? 5 : 5,
          fontFamily: `"IBM Plex Sans", sans-serif`,
        }}
      >
        <Grid
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Grid
            sx={{
              borderRadius: 1,
              my: laptopScreen ? 2 : 5,
              cursor: "pointer",
              width: mobileScreen ? "100%" : "100%",
            }}
          >
            <Grid
              sx={{
                display: "flex",
                alignItems: mobileScreen ? "flex-start" : "center",
                justifyContent: mobileScreen ? "flex-start" : "center",
                gap: tabScreen ? 1 : 2,
                overflowX: mobileScreen ? "auto" : "hidden",
                msOverflowStyle: "none",
                maxWidth: mobileScreen ? "100%" : "auto",
                whiteSpace: "nowrap",
              }}
            >
              {categories.map((category, index) => (
                <Grid key={category}>
                  <Grid
                    onClick={() => handleCategoryClick(index)}
                    sx={{
                      width: "auto",
                      borderRadius: "25px",
                      py: 1,
                      px: 3,
                      textAlign: "center",
                      background:
                        selectedCategory === index
                          ? "linear-gradient(90deg, #205deb 0%, #3a93f3 50%, #53c7fa 100%)"
                          : "#F5F5F5",
                      color: selectedCategory === index ? "#fff" : "#333",
                      "&:hover": {
                        background:
                          selectedCategory === index
                            ? "linear-gradient(90deg, #205deb 0%, #3a93f3 50%, #53c7fa 100%)"
                            : "#E0E0E0",
                        color: selectedCategory === index ? "#fff" : "#333",
                      },
                      display: "inline-block",
                      // Add conditional active class
                      fontWeight:
                        selectedCategory === index ? "bold" : "normal",
                      textTransform: "capitalize",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: 16,
                        fontWeight: 600,
                        letterSpacing: 1,
                      }}
                    >
                      {category}
                    </Typography>
                  </Grid>
                </Grid>
              ))}
            </Grid>
          </Grid>

          <Grid
            container
            spacing={2}
            sx={{ width: "100%", display: "flex", flexWrap: "wrap" }}
          >
            {currentArticles.map((item, index) => (
              <React.Fragment key={item.id}>
                <Grid item md={3.4} sm={5.5} xs={12} sx={{ display: "flex" }}>
                  <Box
                    sx={{
                      padding: mobileScreen ? "0" : "90px",
                      py: 2,
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "100%",
                    }}
                  >
                    <Card
                      sx={{
                        width: 300,
                        height: "350px",
                        cursor: "pointer",

                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        borderRadius: "16px ",
                        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                      }}
                      onClick={() =>
                        handleBlogNavigate(item.ogUrl, item.category)
                      }
                    >
                      <Grid container sx={{ flexDirection: "column" }}>
                        <Grid
                          item
                          sx={{ height: 220, borderRadius: "16px 16px 0 0" }}
                        >
                          <img
                            src={item.featuredUrl}
                            alt="blogimage"
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }} // Use objectFit for better image handling
                          />
                        </Grid>
                        <Grid item sx={{ width: 275, pt: 2, p: 2 }}>
                          <Typography
                            variant="h3"
                            sx={{
                              color: "#1a1d57",
                              fontWeight: 400,
                              letterSpacing: 1,
                              fontSize: 15,
                              pb: 2,
                              textTransform: "capitalize",
                            }}
                          >
                            {item.blogTitle}
                          </Typography>
                        </Grid>
                      </Grid>
                      <Box>
                        <Button
                          variant="contained"
                          sx={{
                            background:
                              "linear-gradient(90deg, #FF0060 0%, #7933FF 100%)",
                            borderRadius: "25px",
                            color: "#fff",
                            postion: "absolute",

                            padding: "6px 16px",
                            fontSize: "0.875rem",
                            transform: "translate(-75%, -60%)",
                            zIndex: 3,
                            fontWeight: "bold",
                            textTransform: "uppercase",
                            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                            marginLeft: "auto",
                            display: "flex",
                            marginBottom: 2,
                          }}
                        >
                          Read More
                        </Button>
                      </Box>
                    </Card>

                    {index < 3 && index < filteredArticles.length - 3}
                  </Box>
                </Grid>

                {(index + 1 === 1 ||
                  index + 1 === 2 ||
                  index + 1 === 4 ||
                  index + 1 === 5) && (
                    <Grid item md={0.1} key={`divider-${index}`}>
                      {/* <Divider orientation="vertical" sx={{ height: 250 }} /> */}
                    </Grid>
                  )}
              </React.Fragment>
            ))}
          </Grid>
          <Box mt={3} display="flex" justifyContent="center">
            <Pagination
              count={Math.ceil(filteredArticles.length / articlesPerPage)}
              page={currentPage}
              onChange={(event, value) => paginate(value)}
              sx={{
                borderRadius: 1,

                "& .MuiButtonBase-root.MuiPaginationItem-root:hover": {
                  backgroundColor: "#f0f8ff",
                  color: "#1d1a57",
                  borderRadius: 1,
                },
                "& .MuiButtonBase-root.MuiPaginationItem-root.Mui-selected": {
                  backgroundColor: "#1d1a57",
                  color: "#fff",
                  borderRadius: 1,
                  fontWeight: 600,
                },
              }}
            />
          </Box>
        </Grid>
      </Grid>
      <Footer variant="light" />
    </div>
  );
};

export default Blog;
